<template>
  <div :class="$style.stockInfo">
    <table :class="$style.stockInfoTable">
      <thead>
        <tr>
          <th :class="$style.stockInfoTableHeadCell" />
          <th :class="[$style.stockInfoTableHeadCell, $style.stockInfoTableHeadCellText, $style.lineBefore]">
            <lv-icon name="store-16" :size="16" style="vertical-align: unset;" />
            <div>{{ $awt('aw.common.product.stock_information.dealer.store_stock') }}</div>
          </th>
          <th :class="[$style.stockInfoTableHeadCell, $style.stockInfoTableHeadCellText, $style.lineBefore]">
            <lv-icon name="full-screen-16" :size="16" style="vertical-align: unset;" />
            <div>{{ $awt('aw.common.product.stock_information.dealer.logistic_stock') }}</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(stockInfo, index) in stockInfosDisplay" :key="stockInfo.store.id" :class="$style.stockInfoTableRow">
          <td :class="[$style.stockInfoTableRowCell, {[$style.stockInfoTableRowCellLast]: index === stockInfosDisplay.length - 1}]">
            <div :class="$style.stockInfoTableRowDetails">
              <h3 :class="$style.stockInfoTableRowName">
                {{ stockInfo.store.name }}
              </h3>
              <div :class="$style.stockInfoTableRowAddress">
                <lv-button
                  styling="link-primary-version2"
                  :class="$style.stockInfoTableRowAddressLink"
                  :href="stockInfo.mapsUrl"
                  target="_blank"
                >
                  {{ stockInfo.addressText }}
                </lv-button>
              </div>
              <div :class="$style.stockInfoTableRowPhoneNumber">
                {{ $awt('aw.common.product.informations.accordion.product_stock_info.tel', { phone_number: stockInfo.store.phoneNumber }) }}
              </div>
            </div>
          </td>
          <td :class="[$style.stockInfoTableRowStock, $style.stockInfoTableRowCell, $style.lineBefore, {[$style.stockInfoTableRowCellLast]: index === stockInfosDisplay.length - 1}]">
            {{ stockInfo.store.stock }} {{ $awt('aw.global.quantity.piece') }}
          </td>
          <td :class="[$style.stockInfoTableRowStock, $style.stockInfoTableRowCell, $style.lineBefore, {[$style.stockInfoTableRowCellLast]: index === stockInfosDisplay.length - 1}]">
            {{ stockInfo.logistic.stock }} {{ $awt('aw.global.quantity.piece') }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
  import { LvButton, LvIcon } from '~~/common/components/loginet-vue-shop/index';
  import { computed } from 'vue';
  import { createStockInfosList } from '~~/common/utils/stockInfoDisplay';

  const props = defineProps({
    stockInfos: {
      type: Array,
      default: () => [],
    },
  });

  const stockInfosDisplay = computed(() => {
    return createStockInfosList(props.stockInfos);
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
  .stockInfo {
    &Table {
      border-spacing: 0 8px;
      border-collapse: separate;

      &Head {
        &Cell {
          font-size: 14px;
          font-weight: $font-weight-bold-v2;
          line-height: 20px;
          padding: 8px 16px;
          text-align: center;
          border-bottom: 2px solid $color-border;

          &Text {
            width: 132px;
          }
        }
      }

      &Row {
        line-height: 20px;
        margin-bottom: 8px;

        &Cell {
          border-bottom: 1px dashed $color-border;

          &Last {
            border-bottom: none;
          }
        }

        &Details {
          padding-right: 8px;
        }

        &Name {
          font-size: 16px;
          font-weight: $font-weight-bold-v2;
          line-height: 24px;
        }

        &Address {
          &Link {
            font-size: 14px;
            font-weight: $font-weight-medium-v2;
            line-height: 20px;
            width: auto;
            padding: 0;
            text-align: left;
            text-decoration: underline;
          }
        }

        &PhoneNumber {
          font-size: 14px;
          font-weight: $font-weight-normal-v2;
          line-height: 20px;
          padding-bottom: 12px;
          color: $color-text-secondary;
        }

        &Stock {
          font-size: 14px;
          line-height: 20px;
          text-align: center;
        }
      }
    }
  }

  .lineBefore {
    position: relative;

    &::before {
      position: absolute;
      top: 50%;
      left: 0;
      display: block;
      width: 1px;
      height: 36px;
      content: "";
      transform: translateY(-50%);
      background-color: $color-border;
    }
  }
</style>
